import Vue from 'vue'
import App from './app'
import store from './store'
import router from './router'
import './plugins'
import '@/views/export'

Vue.config.productionTip = true;

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});
